import { render } from "./competence-matrix-education.vue?vue&type=template&id=b1cc1b34"
import script from "./competence-matrix-education.vue?vue&type=script&lang=js"
export * from "./competence-matrix-education.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/applications/competence/competence-matrix-education.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "b1cc1b34"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('b1cc1b34', __exports__)) {
    api.reload('b1cc1b34', __exports__)
  }
  
  module.hot.accept("./competence-matrix-education.vue?vue&type=template&id=b1cc1b34", () => {
    api.rerender('b1cc1b34', render)
  })

}


export default __exports__